import styled from '@emotion/styled';
import useReduceMotion from '@shared/hooks/useReducedMotion';
import { useTranslation } from 'react-i18next';

// TODO ADMIN: Update main content id if needed

interface ISkipToMainProps {
    scrollToId: string;
}

export default function SkipToMain({ scrollToId }: ISkipToMainProps) {
    const { t } = useTranslation();
    const isReducedMotion = useReduceMotion();

    const handleClick = () => {
        const element = document.getElementById(scrollToId);
        if (element) {
            element.focus();
            element.scrollIntoView({ behavior: isReducedMotion ? 'instant' : 'smooth' });
        }
    };

    return <SkipToMainLink onClick={handleClick}>{t('common:skipToMain')}</SkipToMainLink>;
}

const SkipToMainLink = styled.button`
    position: absolute;
    top: -40px;
    left: 0;
    background: ${({ theme }) => theme.color.text};
    color: ${({ theme }) => theme.color.background};
    padding: 0.5rem 1rem;
    z-index: 100;
    text-decoration: none;
    font-weight: 700;
    transition: top 0.3s;
    &:focus {
        top: 0;
    }
`;
